import i18next from "i18next";
import i18nextXhrBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const path = location.pathname.split("/")[1];
const url = location.protocol + "//" + location.host + "/" + path;

export const i18n = (language: string): Promise<any> =>
    i18next
        .use(i18nextXhrBackend)
        .use(initReactI18next)
        .init({
            debug: true,
            fallbackLng: language,
            interpolation: {
                escapeValue: false
            },
            lng: language,
            backend: {
                loadPath: url + "/locales/" + language + "/translation.json"
            }
        });
